import React from 'react';
import { styled } from '@glitz/react';
import { translate } from '@polarnopyret/scope/index';
import ProductListItemViewModel from '../../Product/ProductListing/ProductListItemViewModel.type';
import { Close16x16 } from '../Icons/Close';
import ProductCard from '../../Product/ProductCard';
import ProductCardList from '../../Product/SwipeableList';
import { StyleOrStyleArray } from '@glitz/type';
import Modal, { ModalScrollableContent, ModalTopContent } from '../SharedComponents/atoms/Modal';
import * as style from 'Shared/Style';

type RequiredPropType = {
  modalIsShown: boolean;
  hideModal: () => void;
  products: ProductListItemViewModel[];
  isMobile: boolean;
};

const BaseSpan = styled.span({
  fontStyle: 'normal',
  fontWeight: 500,
  textTransform: 'uppercase',
  lineHeight: '100%',
});

const ProductLabel = styled(BaseSpan, {
  alignItems: 'center',
  fontSize: '40px',
  display: 'flex',
});

const ProductCount = styled(BaseSpan, {
  fontSize: '14px',
  letterSpacing: '0.01em',
});

const Heading = styled.div({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'space-between',
  padding: { xy: 0 },
  gap: '8px',
});

const TopContent = styled.div({
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%'
})

const TopContentClose = styled(Close16x16, {
  cursor: 'pointer'
})

const ProductCardWrap = styled.div({
  marginBottom: '24px'
})

export const QuickShopProductsModal = ({
  products,
  modalIsShown,
  hideModal,
  isMobile
}: RequiredPropType & { css?: StyleOrStyleArray; }) => {

  return (
    <Modal modalIsShown={modalIsShown} hideModal={hideModal} zIndex={style.ZIndex.Overlay}>
      <ModalTopContent>
        <TopContent>
          <Heading>
            <ProductLabel>{translate('/site/shared/products')}</ProductLabel>
            <ProductCount>({products?.length})</ProductCount>
          </Heading>
          <TopContentClose onClick={hideModal} />
        </TopContent>
      </ModalTopContent>
      <ModalScrollableContent css={{ marginTop: isMobile ? '8px' : '16px' }}>
        {isMobile &&
          <ProductCardList
            products={products}
            isCompact={isMobile}
            cellSpacing={8}
            quickAddToCart={true}
          />
        }
        {!isMobile && <>
          {products?.map((product, index) => (
            <ProductCardWrap key={index + '-' + product.itemNumber}>
              <ProductCard product={product} listIndex={index} quickAddToCart={true} />
            </ProductCardWrap>
          ))}
        </>}
      </ModalScrollableContent>
    </Modal>
  );
};

export default QuickShopProductsModal;